/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{height:100%}#container[_ngcontent-%COMP%]{height:100%}.filter-placeholder[_ngcontent-%COMP%]{margin-top:4px}#outer-info[_ngcontent-%COMP%]{width:100%}#inner-info[_ngcontent-%COMP%]{display:table;margin:20px auto}td[_ngcontent-%COMP%]{height:30px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}  .ui-dropdown{min-width:50px}"];
export { styles as styles };
